export default function arraySplitter(array, column) {
  const result = [];

  let max     = Math.round(array.length / column),
      current = -1;

  array.forEach((col, index) => {
    if (index % max === 0) {
      current++;
    }
    if (result[current] === undefined) {
      result[current] = [];
    }
    result[current].push(col);
  });

  return result;
}





// WEBPACK FOOTER //
// ./src/js/helpers/array-splitter.js